<!-- eslint-disable vue/max-len -->
<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.07439 2.14311C6.90922 0.618962 9.09078 0.618963 9.9256 2.14311L15.725 12.7311C16.5303 14.2013 15.4707 16 13.7994 16H2.20064C0.529314 16 -0.530252 14.2013 0.275029 12.7311L6.07439 2.14311ZM7 6C7 5.44772 7.44772 5 8 5C8.55229 5 9 5.44772 9 6V10C9 10.5523 8.55229 11 8 11C7.44772 11 7 10.5523 7 10V6ZM8 12C7.44772 12 7 12.4477 7 13C7 13.5523 7.44772 14 8 14C8.55229 14 9 13.5523 9 13C9 12.4477 8.55229 12 8 12Z"
      fill="#050038"
    />
  </svg>
</template>
